import { initializeApp, getApps, FirebaseApp } from "firebase/app";
import { getStorage, FirebaseStorage } from "firebase/storage";

let appInstance: FirebaseApp | null = null;
let storageInstance: FirebaseStorage | null = null;

export function getFirebaseApp(): FirebaseApp {
  if (appInstance) return appInstance;

  // Get Firebase config from environment variables
  const apiKey = process.env.TOKENS_LAUNCHPAD_VITE_FIREBASE_API_KEY || '';
  const projectId = process.env.APPCONSTANTS_LAUNCHPAD_LAUNCHPADVITE_FIREBASE_PROJECT_ID || '';
  const storageBucket = process.env.APPCONSTANTS_LAUNCHPAD_LAUNCHPADVITE_FIREBASE_BUCKET || `${projectId}.firebasestorage.app`;

  // Validate required Firebase configuration
  if (!apiKey || apiKey === 'your-firebase-api-key' || apiKey.trim() === '') {
    throw new Error('Firebase API key is not configured. Please set TOKENS_LAUNCHPAD_VITE_FIREBASE_API_KEY in your environment variables.');
  }

  if (!projectId || projectId === 'your-firebase-project-id' || projectId.trim() === '') {
    throw new Error('Firebase Project ID is not configured. Please set APPCONSTANTS_LAUNCHPAD_LAUNCHPADVITE_FIREBASE_PROJECT_ID in your environment variables.');
  }

  // Construct config (authDomain and storageBucket are derived from projectId or explicit bucket)
  const config = {
    apiKey: apiKey,
    authDomain: `${projectId}.firebaseapp.com`,
    projectId: projectId,
    storageBucket: storageBucket,
  };

  appInstance = getApps().length ? getApps()[0] : initializeApp(config);
  return appInstance;
}

export function getFirebaseStorage(): FirebaseStorage {
  if (storageInstance) return storageInstance;
  const app = getFirebaseApp();
  storageInstance = getStorage(app);
  return storageInstance;
}


